import React from 'react';
import cn from 'classnames';
import TagsFiltersModal from '../TagsFiltersModal/';
import SelectList from '../SelectList';
import { useTrans } from 'utils/localisation';

import * as styles from './ModalContent.module.scss';

export default function ModalContent({
  showTags,
  setShowTags,
  flags,
  filters,
  setFilters,
  filtersOptions,
  classname,
}) {
  const t = useTrans(['filters', 'common']);

  const setItem = (item, option, type) =>
    setFilters(prev => ({
      ...prev,
      [option]: type === 'radio' ? item.slice(-1) : item,
    }));

  const clear = option => {
    setFilters(prev => ({
      ...prev,
      [option]: [],
    }));
  };

  return (
    <div className={cn(styles.content, classname)}>
      <div className={styles.scrollWrapper}>
        {showTags && (
          <TagsFiltersModal
            className={styles.tagsWrapper}
            filters={filters}
            setFilters={setFilters}
            flags={flags}
            setShowTags={setShowTags}
          />
        )}
        {Object.keys(filtersOptions).map(option => {
          const { type, values, titleKey, withSearch } = filtersOptions[option];

          return (
            <SelectList
              key={option}
              className={styles.selectWrapper}
              title={t(titleKey)}
              options={values}
              onSelect={item => setItem(item, option, type)}
              clear={() => clear(option)}
              selected={filters[option]}
              withSearch={withSearch}
              type={type}
              flags={flags}
            />
          );
        })}
      </div>
    </div>
  );
}
